import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Locations() {
  const locations = [{
    title: 'Howell Showroom & Main Service Center',
    address: '222 W Grand River Ave, Howell, MI 48843',
    phone: '517-545-7772',
    phoneLink: 'tel:5175457772'
  }, {
    title: 'Ann Arbor Satellite Office',
    address: '2723 South State St, Suite 150, Ann Arbor, MI 48104',
    phone: '734-887-6556',
    phoneLink: 'tel:7348876556'
  }, {
    title: 'Novi Satellite Office',
    address: '39555 Orchard Hill Place, Suite 600, Novi, MI 48375',
    phone: '248-924-9899',
    phoneLink: 'tel:2489249899'
  }];
  return <section className="py-20 bg-slate-50 border-t border-slate-200" data-id="element-739" data-mp="1evrouhl2cdrz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-740" data-mp="1ey5jipbtznz0">
        <div className="max-w-3xl mx-auto text-center mb-16 anim-on-scroll" data-id="element-741" data-mp="34canq1kkpvw7">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-6" data-id="element-742" data-mp="39alu22bnto9o">
            Commercial Glass Near Howell, Ann Arbor, Novi & Southeast Michigan
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-743" data-mp="1mhlfvjvimujb">
            Kosin’s Glass serves commercial glass clients across Southeast
            Michigan and Michigan, including Howell, Ann Arbor, Novi, Brighton,
            Fenton, Hartland, Fowlerville, Northville, Lansing, East Lansing,
            Grand Blanc, Webberville, Williamston, Livonia, Milford, Pinckney,
            Whitmore Lake, Wixom, Oakland County, Livingston County, Ingham
            County, Washtenaw County, Wayne County and the greater Detroit metro
            area. Select larger commercial glazing projects may be available
            outside Michigan depending on scope.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-744" data-mp="1cls07rmi2kxb">
          {locations.map((loc, idx) => <div key={idx} className="bg-white rounded-lg p-6 border border-slate-200 shadow-sm scroll-fade-up" style={{
          animationDelay: `${idx * 0.1}s`
        }} data-id="element-745" data-mp="2nyksr4n47def" data-mpi={idx}>
              <h3 className="kosins-heading text-2xl text-neutral-900 mb-4" data-id="element-746" data-mp="2zzu9ogo3h6vx">
                {loc.title}
              </h3>
              <div className="space-y-3" data-id="element-747" data-mp="350rnkh22nerm">
                <div className="flex items-start gap-3 text-slate-600" data-id="element-748" data-mp="39yt52xjun60z">
                  <MapPin className="w-5 h-5 text-primary-600 shrink-0 mt-0.5" data-id="element-749" data-mp="39wysq7mn8m8i" />
                  <span className="text-sm" data-id="element-750" data-mp="2cd479e7u3aas">{loc.address}</span>
                </div>
                <div className="flex items-center gap-3 text-slate-600" data-id="element-751" data-mp="2hb5r41d33dnb">
                  <Phone className="w-5 h-5 text-primary-600 shrink-0" data-id="element-752" data-mp="2m977gej4kyv3" />
                  <a href={loc.phoneLink} className="text-sm font-semibold hover:text-primary-600 transition-colors" data-id="element-753" data-mp="2r0755m02jkyn">
                    {loc.phone}
                  </a>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-navy-900 rounded-lg p-8 max-w-2xl mx-auto text-center text-white anim-on-scroll" data-id="element-754" data-mp="1r0wx1j448ras">
          <div className="flex justify-center mb-4" data-id="element-755" data-mp="1m10rvgjomttn">
            <Clock className="w-8 h-8 text-primary-400" data-id="element-756" data-mp="1lz7i3sdrvthf" />
          </div>
          <h3 className="kosins-heading text-2xl text-white mb-4" data-id="element-757" data-mp="1h0mi9u2fnbti">
            Business Hours
          </h3>
          <div className="space-y-2 text-slate-300" data-id="element-758" data-mp="1c2urj3dixvqw">
            <p data-id="element-759" data-mp="18216chrguv1p">Monday–Friday: 8:00 a.m. to 5:00 p.m.</p>
            <p data-id="element-760" data-mp="183lxryihhxvc">Saturday: 9:00 a.m. to 3:00 p.m.</p>
            <p className="text-slate-400" data-id="element-761" data-mp="13aj0pgei06ae">Sunday: Closed</p>
          </div>
        </div>
      </div>
    </section>;
}